import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { api } from '../utils/api';

const DEFAULT_NAME = 'חנות יצירות ומלאכות';

export default function Header() {
  const { count, setIsOpen } = useCart();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [showContact, setShowContact] = useState(false);
  const [contactInfo, setContactInfo] = useState({ phone: '', email: '' });
  const [storeName, setStoreName] = useState(DEFAULT_NAME);
  const [logoUrl, setLogoUrl] = useState('');
  const [logoError, setLogoError] = useState(false);

  useEffect(() => {
    api.get('/settings').then(s => {
      if (s.store_name) setStoreName(s.store_name);
      if (s.store_logo) setLogoUrl(s.store_logo);
    }).catch(() => {});
  }, []);

  const openContact = () => {
    api.get('/settings').then(s => {
      setContactInfo({ phone: s.contact_phone || '', email: s.contact_email || '' });
    }).catch(() => {});
    setShowContact(true);
  };

  return (
    <header className="header">
      <div className="header-inner">
        <div className="header-logo" onClick={() => navigate('/')} style={{ transition: 'transform .2s', cursor: 'pointer' }}
          onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.05)'}
          onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}>
          {logoUrl && !logoError && (
            <img src={logoUrl} alt={storeName} onError={() => setLogoError(true)} />
          )}
          <span>{storeName}</span>
        </div>
        <nav className="header-nav">
          <button className={`nav-btn ${pathname === '/' ? 'active' : ''}`} onClick={() => navigate('/')}>קטלוג</button>
          <button className="nav-btn" onClick={openContact}>📞 יצירת קשר</button>
          <button className="cart-btn" onClick={() => setIsOpen(true)}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/>
              <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>
            </svg>
            עגלה
            {count > 0 && <span className="cart-badge">{count}</span>}
          </button>
        </nav>
      </div>

      {showContact && (
        <div className="modal-overlay" onClick={() => setShowContact(false)}>
          <div className="modal" onClick={e => e.stopPropagation()} style={{ maxWidth: 380 }}>
            <div className="modal-title">📞 יצירת קשר</div>
            {(contactInfo.phone || contactInfo.email) ? (
              <div style={{ padding: '8px 0 16px' }}>
                {contactInfo.phone && (
                  <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 16 }}>
                    <span style={{ fontSize: 24 }}>📱</span>
                    <div>
                      <div style={{ fontSize: 12, color: 'var(--text-light)', marginBottom: 2 }}>טלפון</div>
                      <a href={`tel:${contactInfo.phone}`} style={{ fontWeight: 700, color: 'var(--primary-dark)', textDecoration: 'none', fontSize: 18 }} dir="ltr">{contactInfo.phone}</a>
                    </div>
                  </div>
                )}
                {contactInfo.email && (
                  <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                    <span style={{ fontSize: 24 }}>✉️</span>
                    <div>
                      <div style={{ fontSize: 12, color: 'var(--text-light)', marginBottom: 2 }}>אימייל</div>
                      <a href={`mailto:${contactInfo.email}`} style={{ fontWeight: 700, color: 'var(--primary-dark)', textDecoration: 'none' }} dir="ltr">{contactInfo.email}</a>
                    </div>
                  </div>
                )}
              </div>
            ) : (
              <p style={{ color: 'var(--text-light)', padding: '16px 0' }}>פרטי הקשר טרם הוגדרו.</p>
            )}
            <div className="modal-actions">
              <button className="btn btn-cancel" onClick={() => setShowContact(false)}>סגור</button>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
